import { render, staticRenderFns } from "./XInputEditor.vue?vue&type=template&id=c8dda670&scoped=true"
import script from "./XInputEditor.vue?vue&type=script&lang=js"
export * from "./XInputEditor.vue?vue&type=script&lang=js"
import style0 from "./XInputEditor.vue?vue&type=style&index=0&id=c8dda670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8dda670",
  null
  
)

export default component.exports